import {Row, Col , Card} from 'antd';

import '../style/style.css';
import StatusMonitorContainer from '../../StatusMonitorThingy/container/table_container';


export interface DashboardViewProps{
    name:string[];
    refreshInterval:string;
}

/**
 * The hub's start page: its own figures.
 *
 * Until 01.10.2026 it also carried three building blocks of the Vodin
 * interface - the classification boxes, the vulnerability graph and table.
 * They ask api/Vulnerabilities/tripleview, /grouping and /tolist, which only a
 * spoke answers; the hub has no scan results, said 404 to each, and every
 * visit showed "The hub does not know this address" (since 2023).
 */
export function DashboardView(){
    return (
        <div  className="site-card-wrapper">
        <Row gutter={16}>
            <Col span={24}>
           <StatusMonitorContainer id={"StatusMonitor"} /> 
            </Col>
        </Row>
        <Row gutter={16}>
            <Col span={24}>
            <Card title="Vulnerability News">

            </Card>
            </Col>
        </Row>
      </div>
    )
}
